/*
	OneGWP 2.0.0 Usage (Webpack)
	Yang @onerockwell
	
	Simple rule based GWP
	Rule: has none gift item in cart, get the free gift (defined in theme settings)
*/

// Import all dependencies here
import Backbone from 'backbone';

import '../../styles/modules/oneGWP.scss';
import { include } from 'underscore';

// Define a new console, to enable debugging logs please set 1r_debugging cookie with value of true using `ORW.utilities.setCookie('1r_debugging',true)`
const console = (function(oldCons){
	ORW.debugging = ORW.utilities.getCookie('1r_debugging');
    return {
        log: function(text){
            ORW.debugging == `true` && oldCons.log(text);
        },
        info: function (text) {
            ORW.debugging == `true` && oldCons.info(text);
        },
        warn: function (text) {
            ORW.debugging == `true` && oldCons.warn(text);
        },
        debug: oldCons.debug,
        error: function (text) {
            oldCons.error(text);
            if (window?.newrelic) {
                var err = new Error(text);
                window.newrelic.noticeError(err);
            }
        }
    };
}(window.console));

// Define the Backbone View here (Optional)
const OneGWPView = Backbone.View.extend({
	
	initialize: async function (settings) {
		const self = this

		console.log(`GWP Config: Init GWP ...`);

		const countryCode = ORW.utilities.getCookie('localization');

		if (!ORW.GWP || ORW.GWP.enable != `true`) {
			console.log(`GWP Config: GWP is disabled`);
			return false
		}


		// Global variables
		self.tiers = {}
		self.tiersAllVariants = []
		self.defaultTierProduct	= null

		self.currentTier = null
		self.currentFreeGift = null

		//Option to add all available products instead of giving the option to the customer
		self.addMultiple = (ORW.GWP.multiple == `true`)
		self.restrictInternational = (ORW.GWP.restrict_international == `true`)

		// Add International Check
		if (self.restrictInternational && countryCode && countryCode != "US"){
			console.log('GWP: International GWP Disabled');
			//delete all existing GWPs
			await self.removeAllGWPs();
			return false;
		}

		// Rendering and GWP products data prep
		if (!self.prepDataAndRender()) return

		// Start the cart watcher
		const myCartWatcher = new CartWatcher
		myCartWatcher.init()
		window.addEventListener("cart_changed", async (e) => {
			console.log(`Cart updated`);
			console.log(e.detail)
			const cartDetails = e.detail
			if (cartDetails.currentCart) await self.validate(cartDetails.currentCart)
		})

		// Start the action watcher
		self.action = {}
		self.actionProxy = new Proxy(self.action, {
			set: function (target, key, value) {
				console.log(`GWP Action: ${key} - ${value}`)
				target[key] = value	// key will be `loading`, value will be boolean `true` or `false`
				if (value) {
					document.body.classList.add(`gwp-in-action`)
				} else {
					document.body.classList.remove(`gwp-in-action`)
				}
				return true
			}
		})
		self.actionProxy.loading = false
	},

	events: {
		'click .free-gift.active:not(.added)': function (e) {
			if(!self.addMultiple){
				const self = this
				const variantId = e.currentTarget.getAttribute(`data-variant-id`)
				self.swapFreeGift(variantId)
			}
		},
	},

	onCartUpdate: async function (e) {

	},

	prepDataAndRender: function () {
		const self = this

		/*
			Assume one and only one section loaded
		*/
		const gwpModule = document.querySelector(`.gwp-module`)
		const gwpWrapper = document.querySelector(`.gwp-wrapper`)
		const freeGifts = document.querySelectorAll(`.free-gift-collections .free-gift`)
		const freeGiftsArray = Array.from(freeGifts)

		if (!gwpModule || !gwpWrapper || !freeGiftsArray.length) {
			console.log(`GWP Config: GWP not configured properly, GWP disabled`);
			return false
		}

		// consider sort the free gifts by tier attribute
		freeGiftsArray.forEach((freeGift, index) => {
			const tierKey = freeGift.getAttribute(`data-tier`) // tier_1, tier_2, tier_3
			const tierKeyAttr = `data-${ tierKey.replace(`_`, `-`) }` // data-tier-1, data-tier-2, data-tier-3

			const variantId = freeGift.getAttribute(`data-variant-id`)
			const productHandle = freeGift.getAttribute(`data-handle`)

			if (!self.tiersAllVariants.includes(variantId)) {
				self.tiersAllVariants.push(variantId)
			}

			if (!self.tiers[tierKey]) {
				const threshold = gwpWrapper.getAttribute(tierKeyAttr) ? parseInt(gwpWrapper.getAttribute(tierKeyAttr)) * 100 : 0
				if (threshold) {
					self.tiers[tierKey] = {
						products: [],
						threshold: parseInt(threshold)
					}
				}
			}

			self.tiers[tierKey] && self.tiers[tierKey].products.push({
				variantId: variantId,
				productHandle: productHandle
			})
		});

		if (!Object.keys(self.tiers).length) {
			console.log(`GWP Config: No tier found, GWP disabled`);
			return false
		}
		console.log(`GWP Config: Tiers configured`)
		console.log(self.tiers)
		console.log(`GWP Config: Tiers variants configured`)
		console.log(self.tiersAllVariants)
		console.log(`GWP Config: Add Multiple `+(self.addMultiple?`enabled`:`disabled`))

		// Set the default free gift product to the first product in the first tier
		self.defaultTierProduct = self.tiers[Object.keys(self.tiers)[0]].products[0]
		if (!self.defaultTierProduct || !self.defaultTierProduct.variantId ) {
			console.log(`GWP Config: No free gift configured, GWP disabled`);
			return false
		}
		console.log(`GWP Config: Default free gift product is ${self.defaultTierProduct.variantId} (variantId)`)

		// Inject the GWP module		
		if(ORW.GWP.multiple == 'true'){
			document.querySelectorAll(`.cart-items-wrapper`).forEach((el) => {
				el.insertAdjacentHTML(
					'afterbegin', 
					`<div class="gwp-module-container multiple-gwps">${gwpModule.innerHTML}</div>`
				)
			})	
		}else{
			document.querySelectorAll(`.cart-items-wrapper .cart-items`).forEach((el) => {
				el.insertAdjacentHTML(
					'afterend', 
					`<div class="gwp-module-container">${gwpModule.innerHTML}</div>`
				)
			})	
		}		

		// Only apply darg slider to minibag for desktop usage
		self.slider(document.querySelector(`#MiniCart .gwp-wrapper`))

		// Lazyload update
		window.ORW.lazyload && window.ORW.lazyload.update()

		return true
	},

	validate: async function (items) {
		const self = this
		let gwpCartTotal = 0

		console.log(`GWP Validation: Cart validating ... `)

		if (items.length) {
			console.log(items);
			// Validate tiers and precheck
			gwpCartTotal = items.reduce((acc, item) => {
				// if (!item.properties || !item.properties._GWP) {
				// 	return acc + item.final_line_price;
				// }
				if (!self.tiersAllVariants.includes(`${item.variant_id}`)) {
					return acc + item.final_line_price;
				}
				return acc;
			}, 0);
			console.log(`GWP Validation: Cart total ${gwpCartTotal}`);
			const validTiers = Object.keys(self.tiers).filter((tier) => {
				return gwpCartTotal >= self.tiers[tier].threshold
			})
			self.currentTier = validTiers.length ? validTiers[validTiers.length - 1] : null
			// DD-2596 Check if session disallow_auto_gwp_add is set disallow the auto addition of gwp products and remove all the gwps even if threshold matches
			if(sessionStorage.getItem('disallow_auto_gwp_add') && sessionStorage.getItem('disallow_auto_gwp_add') === 'true'){
				await self.removeAllGWPs();
				self.updateMessage(gwpCartTotal)
				return
			}
			// Perform validation actions
			await self.validationActions(validTiers, items)
		} else {
			self.currentTier = null
			self.currentFreeGift = null
			console.log(`GWP Validation: no action`)
		}

		self.updateMessage(gwpCartTotal)
	},

	getProductByhandle: async function(handle) {
		const self = this
		try {
			const response = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);
			const responseData = await response.json();
			return responseData;
		} catch (error) {
			console.log(error);
			return false;
		}
	},

	swapFreeGift: async function (variantId) {
		/*
			The strategy here is to use the update api to make the first call to remove the current free gift and add the new free gift
			then making a second call to update the line item property of the new free gift with `_GWP`

			The reason for this is that the update api does not allow to update the line item property directly, so we need to make two calls.
			More important, our validation is triggered at every cart update, which means we cannot just remove the current free gift then add
			the new one, since the validation will add the default free gift after the removal call.
		*/
		const self = this
		let swapFlag = false

		if (!variantId) {
			console.log(`GWP Action: No variantId provided for swapping`)
			return
		}

		if (self.currentFreeGift && self.currentFreeGift.variant_id == variantId) {
			// Same free gift, no action
			console.log(`GWP Action: Same free gift, no action`);
			return
		} else if (self.currentFreeGift) {
			// Do the swap
			console.log(`GWP Action: Swap free gift ...`);
			const url = window.Shopify.routes.root + 'cart/update.js'
			const updates = {
				[self.currentFreeGift.variant_id]: 0,
				[variantId]: 1
			};
			const config = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({updates}),
			};

			self.actionProxy.loading = true
			try {
				const response = await fetch(url, config)
				if(!response.ok){
					throw new Error("Cart Update returned status code "+response.status);
				}
				self.GWPChanged(response, `gwp_gift_swapped`)
				swapFlag = true
			} catch (error) {
				console.log(`GWP Action: Swap/Update free gift error`)
				console.log(error)
				swapFlag = false
			}
			self.actionProxy.loading = false
		} else {
			// Add the free gift
			console.log(`GWP Action: Add free gift ...`);
			await self.addFreeGift(variantId)
		}

		if (swapFlag) {
			const url = window.Shopify.routes.root + 'cart/change.js'
			const formData = {
				'id': `${variantId}`,
				'properties': {
					'_GWP': `1`
				}
			};
			const config = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(formData),
			};

			self.actionProxy.loading = true
			try {
				const response = await fetch(url, config)
				if(!response.ok){
					throw new Error("Cart Update returned status code "+response.status);
				}
				self.GWPChanged(response, `gwp_gift_swap_updated`)
				// if (document.body.classList.contains(`template-cart`)) {
				// 	location.reload()
				// }
			} catch (error) {
				console.log(`GWP Action: Swap/Update free gift error (property update)`);
				console.log(error);
			}
			self.actionProxy.loading = false
		}
	},

	addFreeGift: async function (variantId = null) {
		const self = this
		const url = window.Shopify.routes.root + 'cart/add.js' 
		const id = variantId ? variantId : self.defaultTierProduct.variantId
		const formData = {
			'id': `${id}`,
			'quantity': 1,
			'properties': {
				'_GWP': `1`
			}
		}

		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData),
		};

		self.actionProxy.loading = true
		try {
			const response = await fetch(url, config)
			if(!response.ok){
				throw new Error("Cart Update returned status code "+response.status);
			}
			self.GWPChanged(response, `gwp_gift_added`)
			// if (document.body.classList.contains(`template-cart`)) {
			// 	location.reload()
			// }
		} catch (error) {
			console.log(`GWP Action: Adding free gift error`)
			console.log(error)
		}
		self.actionProxy.loading = false
	},

	addFreeGifts: async function (variantIds) {
		const self = this
		const url = window.Shopify.routes.root + 'cart/add.js'

		console.log("GWP Action: Adding multiple free gifts")
		console.log(variantIds)
		if (!variantIds || !variantIds.length){
			return false
		}
		const formData = {
			'items': []
		};
		variantIds.forEach((id) => {
			formData.items.push({
				'id': `${id}`,
				'quantity': 1,
				'properties': {
					'_GWP': `1`
				}
			})
		});
		console.log(formData);

		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData),
		};

		self.actionProxy.loading = true
		try {
			const response = await fetch(url, config)
			if(!response.ok){
				throw new Error("Cart Update returned status code "+response.status);
			}
			self.GWPChanged(response, `gwp_gift_added`)
			// if (document.body.classList.contains(`template-cart`)) {
			// 	location.reload()
			// }
		} catch (error) {
			console.log(`GWP Action: Adding free gifts error`)
			console.log(error)
		}
		self.actionProxy.loading = false
	},

	removeFreeGift: async function (variantId = null) {
		const self = this
		const url = window.Shopify.routes.root + 'cart/change.js'
		const id = variantId ? variantId : self.defaultTierProduct.variantId

		const formData = {
			'id': `${id}`,
			'quantity': 0
		};
		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData),
		};

		self.actionProxy.loading = true
		try {
			const response = await fetch(url, config)
			if(!response.ok){
				throw new Error("Cart Update returned status code "+response.status);
			}
			self.GWPChanged(response, `gwp_gift_removed`)
			// if (document.body.classList.contains(`template-cart`)) {
			// 	location.reload()
			// }
		} catch (error) {
			console.log(`GWP Action: Remove free gift error`);
			console.log(error);
		}
		self.actionProxy.loading = false
	},

	removeFreeGifts: async function (variantIds) {
		const self = this
		const url = window.Shopify.routes.root + 'cart/update.js'

		if (!variantIds || !variantIds.length){
			return false
		}
		const formData = {
			'updates': {}
		};

		variantIds.forEach((id) => {
			formData.updates[id] = 0
		})

		console.log("GWP Action: Removing Free Gifts")
		console.log(formData)

		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData),
		};
		self.actionProxy.loading = true
		try {
			console.log("GWP Action: Update sending")
			const response = await fetch(url, config)
			if(!response.ok){
				throw new Error("Cart Update returned status code "+response.status);
			}
			self.GWPChanged(response, `gwp_gift_removed`)
			// if (document.body.classList.contains(`template-cart`)) {
			// 	location.reload()
			// }
		} catch (error) {
			console.log(`GWP Action: Remove free gifts error`);
			console.log(error);
		}
		self.actionProxy.loading = false
	},

	async fetchCart() {
		const response = await fetch('/cart.js');
		return response.json();
	},

	removeAllGWPs: async function() {
		// international or other situation to disable GWPs, remove any currently in cart.
		const newCart = await this.fetchCart();
		const cartItems = newCart.items;
		const freeGiftsInCart = cartItems.filter((item) => item.properties && item.properties._GWP);
		console.log("Removing GWP");
		console.log(freeGiftsInCart);
		if(freeGiftsInCart && freeGiftsInCart.length){
			const variantIdsToRemove = freeGiftsInCart.map((x) => {
				return x.variant_id;
			});
			console.log(variantIdsToRemove);
			const self = this
			const url = window.Shopify.routes.root + 'cart/update.js'

			if (!variantIdsToRemove || !variantIdsToRemove.length){
				return false
			}
			const formData = {
				'updates': {}
			};

			variantIdsToRemove.forEach((id) => {
				formData.updates[id] = 0
			})

			console.log("GWP Action: Removing Free Gifts")
			console.log(formData)

			const config = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(formData),
			};
			try {
				console.log("GWP Action: Update sending")
				const response = await fetch(url, config)
				if(!response.ok){
					throw new Error("Cart Update returned status code "+response.status);
				}
				// Update Cart
				self.GWPChanged(response, `gwp_gift_removed`)
				// refresh cart after removing GWP items.
				const myCartWatcher = new CartWatcher;
				myCartWatcher.init();

			} catch (error) {
				console.log(`GWP Action: Remove free gifts error`);
				console.log(error);
			}
		}
	},

	updateFreeGift: async function (updates = {}) {
		/*
			updates = {
				'variant_id_1': 'qty_1',
				'variant_id_2': 'qty_2',
				...
			}
		*/
		const self = this
		const url = window.Shopify.routes.root + 'cart/update.js'
		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({updates}),
		};

		self.actionProxy.loading = true
		try {
			const response = await fetch(url, config)
			if(!response.ok){
				throw new Error("Cart Update returned status code "+response.status);
			}
			self.GWPChanged(response, `gwp_gift_updated`)
			// if (document.body.classList.contains(`template-cart`)) {
			// 	location.reload()
			// }
		} catch (error) {
			console.log(`GWP Action: Reset/Update free gift error`)
			console.log(error)
		}
		self.actionProxy.loading = false
	},

	validationActions: async function (validTiers, cartItems) {
		const self = this
		const freeGifts = document.querySelectorAll(`.free-gift-collections .free-gift`)
		const freeGiftInCart = cartItems.filter((item) => item.properties && item.properties._GWP)
		// Gifts in cart can not ONLY be variant id's from products selected in theme customizer. 
    // This causes any gifts left behind in a users cart, to not be looked at as a gift during validation whenever that product is deselected from the theme customizer.
		// Leaving this here incase it is needed for sorting of gifts in multi tier/multi product promotions.
    // const freeGiftInCart = cartItems.filter((item) => {
		// 	return self.tiersAllVariants.includes(`${item.variant_id}`)
		// })

		self.currentFreeGift = freeGiftInCart.length ? freeGiftInCart[0] : null
		self.currentFreeGifts = freeGiftInCart.length ? freeGiftInCart : null

		// Reset the free gifts UI
		freeGifts.forEach((el) => {
			el.classList.remove("active", "added")
		});

		if (validTiers.length) {
			// process valid tier actions
			console.log(`GWP Validation: Valid tiers - ${validTiers}`)
			console.log(`GWP Validation: Current valid tier - ${self.currentTier}`)

			// Update the free gifts UI, get the current free gift in cart if any
			validTiers.forEach((tier) => {
				const validTier = self.tiers[tier]
				validTier.products.forEach((product) => {
					const validFreeGift = document.querySelectorAll(`.free-gift-collections .free-gift[data-variant-id="${product.variantId}"]`)		
					validFreeGift.forEach((el) => {
						el.classList.add("active")
						// If add all applicable products option is turned on, check for all added gifts
						if(self.addMultiple){
							if (self.currentFreeGifts && self.currentFreeGifts.find((gift) => {gift.variant_id == product.variantId}) !== undefined){
								el.classList.add("added")
							}
						} else{
							if (self.currentFreeGift && self.currentFreeGift.variant_id == product.variantId) {
								el.classList.add("added")
							}
						}
					})
				})
			})

			console.log(`GWP Validation: Current free gift - ${self.currentFreeGift}`)
			console.log(`GWP Validation: Current free gifts - ${self.currentFreeGifts}`)

			if (!self.currentFreeGift) {
				// Has valid tier but no free gift in cart, add the first free gift from the lowest valid tier
				console.log(`GWP Action: add the default free gift ...`)
				if(self.addMultiple){
					//get all unique active variant IDs
					const variantIds = Array.from(
						document.querySelectorAll(`.free-gift-collections .free-gift[data-variant-id].active`))
						.map((e) => {
							return e.getAttribute('data-variant-id')
						}
					).filter((x, i, a) => a.indexOf(x) == i)
					await self.addFreeGifts(variantIds)
				} else{
					await self.addFreeGift()
				}
			} else {
				// Has valid tier with free gift in cart, check if the free gift in cart still valid
				console.log(`GWP Validation: Has valid tier with free gift in cart, check if the free gift in cart still valid ...`)

				if(self.addMultiple){
					//Validation when all valid GWPs are added
					//get all unique active variant IDs
					const validVariantIds = Array.from(
						document.querySelectorAll(`.free-gift-collections .free-gift[data-variant-id].active`))
						.map((e) => {
							return e.getAttribute('data-variant-id')
						}
					).filter((x, i, a) => a.indexOf(x) == i)
					//get all unique variant IDs currently in cart
					const cartVariantIds = self.currentFreeGifts.map((e) => {return e.variant_id.toString()}).filter((x, i, a) => a.indexOf(x) == i)

					//get GWPs not in cart
					const missingVariantIds = validVariantIds.filter(e => !cartVariantIds.includes(e))
					//get invalid GWPs to be removed
					const invalidVariantIds = cartVariantIds.filter(e => !validVariantIds.includes(e))

					if(missingVariantIds.length){
						console.log("GWP Action: Missing Variant IDs")
						console.log(missingVariantIds)
						await self.addFreeGifts(missingVariantIds)
					} else if(invalidVariantIds.length){
						console.log("GWP Action: Invalid Variant IDs")
						console.log(invalidVariantIds)
						await self.removeFreeGifts(missingVariantIds)
					}
					

				} else{

					// Validate: if the current free gift is in a higher tier, remove the free gift
					const currentFreeGiftTier = Object.keys(self.tiers).find((tier) => {
						return self.tiers[tier].products.some((product) => product.variantId == self.currentFreeGift.variant_id)
					})
					console.log(`GWP Validation: Current free gift tier - ${currentFreeGiftTier}`)
					if (currentFreeGiftTier.toString().localeCompare(self.currentTier) > 0) {
						// The current free gift is in a higher tier, remove the free gift
						console.log(`GWP Action: remove the free gift due to tier change ...`)
						await self.removeFreeGift(self.currentFreeGift.variant_id)
					}

					const qtyValidationUpdates = {}
					// Validate: if the current free gift has more than 1 quantity, reset the quantity to 1
					if (self.currentFreeGift.quantity > 1) {
						console.log(`GWP Validation: Current free gift has more than 1 quantity ...`)
						qtyValidationUpdates[self.currentFreeGift.variant_id] = 1
					}

					// Validate: if the cart has more than one free gift, remove all free gift
					if (freeGiftInCart.length > 1) {
						console.log(`GWP Validation: Cart has more than one free gift ...`)
						freeGiftInCart.forEach((item) => {
							qtyValidationUpdates[item.variant_id] = 0
						})
					}

					if (Object.keys(qtyValidationUpdates).length) {
						console.log(`GWP Action: Cart has exceeded amount of free gifts, reset the free gifts ...`)
						console.log(qtyValidationUpdates)
						await self.updateFreeGift(qtyValidationUpdates)
					}
				}
			}
		} else {
			// process non-valid tier actions
			console.log(`GWP Validation: no valid tier ...`)
			if (self.currentFreeGift) {
				console.log(`GWP Action: remove the free gift due to no valid tier ...`)
				console.log(self.currentFreeGifts)
				//remove multiple gifts
				if (self.addMultiple && self.currentFreeGifts && self.currentFreeGifts.length > 1){
					const variantIdsToRemove = self.currentFreeGifts.map((e) => {return e.variant_id})
					await self.removeFreeGifts(variantIdsToRemove)
				} else{
					await self.removeFreeGift(self.currentFreeGift.variant_id)
				}
			} else {
				console.log(`GWP Action: no action`)
			}
		}
	},

	updateMessage: function (gwpCartTotal) {
		const self = this
		const messagesBlocks = document.querySelectorAll(`.gwp-module-container .gwp-message`)

		if (self.currentTier) {
			messagesBlocks.forEach((el) => {
				el.innerHTML = `${ el.attributes['data-message-qualify'].value }`
			})
		} else {
			const firstTier = Object.keys(self.tiers).length ? self.tiers[Object.keys(self.tiers)[0]] : false
			console.log(firstTier);
			
			if (firstTier && firstTier.threshold > gwpCartTotal) {
				const amountLeft = parseInt(firstTier.threshold - gwpCartTotal)
				messagesBlocks.forEach((el) => {
					const defaultMessage = el.attributes['data-message-default'].value.replace(`__`, Shopify.formatMoney(amountLeft, window.theme.moneyFormat))
					el.innerHTML = `${ defaultMessage }`
				})
			}
		}
	},

	GWPChanged: function (data = {}, eventNameOverride = '') {
		const eventName = eventNameOverride ? eventNameOverride : `gwp_changed`
		const event = new CustomEvent(eventName, { detail: data });
		window.dispatchEvent(event);
	},

	slider: function (slider) {
		let mouseDown = false;
		let startX, scrollLeft;

		const startDragging = (e) => {
			mouseDown = true;
			startX = e.pageX - slider.offsetLeft;
			scrollLeft = slider.scrollLeft;
		}

		const stopDragging = (e) => {
			mouseDown = false;
		}

		const move = (e) => {
			e.preventDefault();
			if(!mouseDown) { return; }
			const x = e.pageX - slider.offsetLeft;
			const scroll = x - startX;
			slider.scrollLeft = scrollLeft - scroll;
		}

		// Add the event listeners (consider update this to only support desktop, since mobile device can do native touch scrolling)
		slider.addEventListener('mousemove', move, false);
		slider.addEventListener('mousedown', startDragging, false);
		slider.addEventListener('mouseup', stopDragging, false);
		slider.addEventListener('mouseleave', stopDragging, false);
	},
	
	destroy: function() {
		const self = this
		self.undelegateEvents()
	}
});

// Define the module here 
const OneGWP = {
	init: function (settings) {
		
		// If using Backbone View
		return new OneGWPView({
			el: document.body,
		});
		
		// If not using Backbone View
		// return this;
	}
}

// Output the module
export default OneGWP;

class CartWatcher {

	init() {
		this.emitCartChanges().then(() => {
			this.observeCartChanges();
		});
	}
  
	async fetchCart() {
		const response = await fetch('/cart.js');
		return response.json();
	}
  
	storeCart(cart) {
		localStorage.setItem('cart', JSON.stringify(cart));
	}
  
	storedCart() {
		return JSON.parse(localStorage.getItem('cart')) || { items: [] };
	}
  
   	findCartChanges(oldCart, newCart) {
		const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
		let result = {
			added: onlyInLeft(newCart.items, oldCart.items),
			removed: onlyInLeft(oldCart.items, newCart.items),
			currentCart: newCart.items,
		};

		oldCart.items.forEach(oi => {
			const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
			if (!ni) return;
			let quantity = ni.quantity - oi.quantity;
			let item = { ...ni };
			item.quantity = Math.abs(quantity);
			quantity > 0
				? result.added.push(item)
				: result.removed.push(item)
		});

		return result;
	}

	async stall(milliseconds) {
        return new Promise(resolve => {
            setTimeout(resolve, milliseconds);
        })
    }
  
	async emitCartChanges() {
		await this.stall(200)	// Wait a few before getting the cart as the request could be WIP.
		const newCart = await this.fetchCart();
		const oldCart = this.storedCart();
		const changes = this.findCartChanges(oldCart, newCart);

		const event = new CustomEvent("cart_changed", { detail: changes });
		window.dispatchEvent(event);

		this.storeCart(newCart);
	}
  
   	observeCartChanges() {
		const cartObserver = new PerformanceObserver((list) => {
			list.getEntries().forEach(async (entry) => {
				const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
				const isCartChangeRequest = /\/cart\//.test(entry.name);
				if (isValidRequestType && isCartChangeRequest) {
					await this.emitCartChanges();
				}
			});
		});
		cartObserver.observe({ entryTypes: ["resource"] });
	}
}